<template>
    <div class="ah-page income-statement-page">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>收支項目關聯設定</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container extend">
            <div class="ah-panel">
                <div class="panel-body">
                    <el-checkbox v-model="showFinAnalysis">財務分析</el-checkbox>
                    <el-checkbox v-model="showIncomeState">綜合損益表</el-checkbox>
                    <el-checkbox v-model="showBalance">資產負債表</el-checkbox>
                    <el-radio v-model="isCompareMode" :label="false">單項</el-radio>
                    <el-radio v-model="isCompareMode" :label="true">雙欄比對</el-radio>
                </div>
            </div>
            <el-row :gutter="15">
                <el-col :sm="isCompareMode ? 12 : 24">
                    <div class="ah-panel">
                        <div class="panel-header gray padding small">
                            <div class="panel-title">
                                <el-select v-model="groupA" @change="onGroupChange">
                                    <el-option v-for="item in groupOptions" placeholder="請選擇" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="panel-body">
                            <trade-state-related-setting-table :group="this.groupA" :showFinAnalysis="showFinAnalysis" :showIncomeState="showIncomeState" :showBalance="showBalance" />
                        </div>
                    </div>
                </el-col>
                <el-col :sm="12" v-if="isCompareMode">
                    <div class="ah-panel">
                        <div class="panel-header gray padding small">
                            <div class="panel-title">
                                <el-select v-model="groupB" @change="onGroupChange">
                                    <el-option v-for="item in groupOptions" placeholder="請選擇" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="panel-body">
                            <trade-state-related-setting-table :group="this.groupB" :showFinAnalysis="showFinAnalysis" :showIncomeState="showIncomeState" :showBalance="showBalance" />
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import { statementTypes } from '@/assets/commonData/options';
import TradeStateRelatedSettingTable from './TradeStateRelatedSettingTable.vue';

export default {
    components: {
        TradeStateRelatedSettingTable,
    },
    data() {
        return {
            isCompareMode: true,
            groupA: null,
            groupB: null,
            showFinAnalysis: false,
            showIncomeState: true,
            showBalance: true,
        };
    },
    created() {
        const { ga, gb } = this.$route.query;
        if (ga) this.groupA = ga;
        else this.groupA = 'cInElseSettings';
        if (gb) this.groupB = gb;
        else this.groupB = 'cOutElseSettings';
    },
    computed: {
        groupOptions() {
            return statementTypes;
        },
    },
    methods: {
        onGroupChange() {
            this.$router.replace({
                name: this.$route.name,
                query: {
                    ga: this.groupA,
                    gb: this.groupB,
                },
            });
        },
    },
};
</script>
<style lang="scss"></style>
